import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'CLIENT_FAV',
  title: 'Come posso aggiungere il mio cliente ai preferiti?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Vai alla scheda Clienti'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CLIENT_FAV/IT_CLIENT_FAV_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Seleziona il cliente di tua scelta'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Clicca sulla stella in alto a destra per aggiungerla o rimuoverla dai tuoi preferiti'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CLIENT_FAV/IT_CLIENT_FAV_2.png`
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_CLIENT_FAV/IT_CLIENT_FAV_3.png`
  }]
};
